export default function generateRandomString() {
  return Math.random().toFixed(5);
}
